module.exports = __webpack_public_path__ + "static/media/E703.a9883c0d.png";